// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CjGJuhNC7dH5WSst7Kjb {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.CjGJuhNC7dH5WSst7Kjb img{
    width: 16px;
    height: 16px;
}

.CjGJuhNC7dH5WSst7Kjb img:hover {
    cursor: pointer;
}

.qvxLkqT4yhFR0fr0sBqr {
    width: 100%;
    display: flex;
    align-items: center;
}

.qvxLkqT4yhFR0fr0sBqr img {
    width: 14px;
    height: 14px;
}

input {
    width: 90%;
    outline: none;
    border-color: transparent;
    font-size: 14px;
    font-family: "Nunito Sans", Sans-serif, serif;
}

.o3m_fO4To4kgxRwM4R45 {
    visibility: hidden;
}

.E8PSbYyPO7yBxc2I72CM {
    display: none;
}

`, "",{"version":3,"sources":["webpack://./src/admin/css/search-base-component.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;AACA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,yBAAyB;IACzB,eAAe;IACf,6CAA6C;AACjD;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB","sourcesContent":[".search_base_component {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n.search_base_component img{\n    width: 16px;\n    height: 16px;\n}\n\n.search_base_component img:hover {\n    cursor: pointer;\n}\n\n.search_inner_container {\n    width: 100%;\n    display: flex;\n    align-items: center;\n}\n\n.search_inner_container img {\n    width: 14px;\n    height: 14px;\n}\n\ninput {\n    width: 90%;\n    outline: none;\n    border-color: transparent;\n    font-size: 14px;\n    font-family: \"Nunito Sans\", Sans-serif, serif;\n}\n\n.hide {\n    visibility: hidden;\n}\n\n.remove {\n    display: none;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"search_base_component": `CjGJuhNC7dH5WSst7Kjb`,
	"search_inner_container": `qvxLkqT4yhFR0fr0sBqr`,
	"hide": `o3m_fO4To4kgxRwM4R45`,
	"remove": `E8PSbYyPO7yBxc2I72CM`
};
export default ___CSS_LOADER_EXPORT___;
